import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import axios from 'axios';

import { useSession } from 'next-auth/react'
import { PuffLoader, PulseLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEye, faFile, faFileCircleCheck, faPeopleGroup, faPersonCircleCheck, faXmark, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

import returnCreatedTimeStamp from '../../../../Functions/timestamps/returnCreatedTimeStamp';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import errorMsg from '../../../../Functions/errorMsg';
import successMsg from '../../../../Functions/successMsg';

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

export default function AppManager({ jobID, closeManager, refreshListings }) {

    const { data: session, status } = useSession();

    const [loadingData, setLoadingData] = useState(true);
    const [appData, setAppData] = useState(null);

    useEffect(() => {
        if(!loadingData) return;
        if(appData) return;
    
        async function getJobApplications() {
    
            const result = await axios.post(`${window.location.origin}/api/jobs/dashboard/getJobAppManager`, {
              requestingUserID: session.user.token.id,
              jobID: jobID
            }).catch((error) => {
                errorMsg(error?.response?.data?.status || error.toString())
            })
    
            if(result && result.status === 200) {
              const data = result.data;
              setAppData(data);
            }
    
            setLoadingData(false);
        }
    
        getJobApplications();
    
      }, [session, status, loadingData, appData])

    function removeApplicationCallback(userOfApplication) {
        var newAppData = {...appData};
        newAppData.applications = appData.applications.filter((app) => userOfApplication !== app.user)
        setAppData(newAppData);

        refreshListings();
    }

    function setAppSelectedCallback(userOfApplication) {
        var newAppData = {...appData};

        appData.applications.forEach((app, index) => {
            if(app.selected || app.user !== userOfApplication) return;
            newAppData.applications[index].selected = true;
        })
        
        setAppData(newAppData);
    }

    function setAppHiredCallback(userOfApplication) {
        var newAppData = {...appData};

        appData.applications.forEach((app, index) => {
            if(app.hired || app.user !== userOfApplication) return;
            newAppData.applications[index].hired = true;
        })
        
        setAppData(newAppData);
    }

    function canManuallyCloseJob() {
        return appData.applications.some((app) => app.selected === true);
    }

    function appOverviewStatus() {
        var totalApps = 0;
        var selectedApps = 0;
        var hiredApps = 0;

        if(appData) {

            const applications = appData.applications;

            totalApps = applications.length;

            applications.forEach((app) => {
                if(app.selected) {
                    selectedApps += 1;
                }
                if(app.hired) {
                    hiredApps += 1;
                }
            })


        }

        return { totalApps, selectedApps, hiredApps }
    }

    const { totalApps, selectedApps, hiredApps } = appOverviewStatus();

    const [viewingApplication, setViewingApplication] = useState(null);
    const [openCloseJob, setOpenCloseJob] = useState(false);

    async function handleCloseJob() {
        if(!appData) return;

        setAppData(null);
        setOpenCloseJob(false);

        const result = await axios.post(`${window.location.origin}/api/jobs/dashboard/deleteJobListing`, {
            requestingUserID: session.user.token.id,
            jobID: jobID
          }).catch((error) => {
              errorMsg(error?.response?.data?.status || error.toString())
          })
  
          if(result && result.status === 200) {
            successMsg("This post has been deleted.");
            refreshListings();
            closeManager();
          }

    }

  return (
    <section id={styles.wrapper}>
        { viewingApplication && <ApplicationViewer data={viewingApplication} closeViewer={() => setViewingApplication(null)} />  }
        { openCloseJob && <div id={styles.closeJobWrapper}>
            <h1>Close Job?</h1>
            <section>
                <button onClick={handleCloseJob}>
                    <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                </button>
                <button onClick={() => setOpenCloseJob(false)}>
                    <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                </button>
            </section>
        </div> }
        { appData === null && <div id={styles.loading}> <PulseLoader size={30} color='#FFFFFF' /> </div> }

        { appData && <div id={styles.content}>
            <nav>
                <FontAwesomeIcon onClick={closeManager} icon={faXmarkCircle} id={styles.exit} />
                <div>
                    <h1>App Manager <FontAwesomeIcon icon={faPeopleGroup} id={styles.icon} /></h1>
                </div>
                <div>
                    <h2>Total Apps: {totalApps}</h2>
                    <h2>Selected Apps: {selectedApps}</h2>
                    <h2 style={{marginBottom: '12px'}}>Hired Apps: {hiredApps}</h2>
                    { canManuallyCloseJob() && <button onClick={() => setOpenCloseJob(true)}>Close Job</button> }
                </div>
            </nav>
            <div>
            { appData.applications.map((app, index) => {
                return <ApplicationCard key={index} data={app} openApplication={() => setViewingApplication(app)} jobID={jobID} removeApplicationCallback={removeApplicationCallback} setAppSelectedCallback={setAppSelectedCallback} setAppHiredCallback={setAppHiredCallback} />
            }) }
            </div>
        </div> }
        
    </section>
  )
}


const ApplicationCard = ({ data, openApplication, jobID, removeApplicationCallback, setAppSelectedCallback, setAppHiredCallback }) => {

    const { data: session, status } = useSession();

    const { displayString, justPosted } = returnCreatedTimeStamp(data.applied);


    const [pending, setPending] = useState(false);

    const [viewed, setViewed] = useState(data.viewed);
    const [selected, setSelected] = useState(data.selected);
    const [hired, setHired] = useState(data.hired);


    const [openConfirmCandidateSelected, setOpenConfirmCandidateSelected] = useState(false);
    const [openConfirmCandidateHired, setOpenConfirmCandidateHired] = useState(false);

    function handleCandidateActions() {
        if(!selected) return setOpenConfirmCandidateSelected(true);
        if(!hired) setOpenConfirmCandidateHired(true); 
    }

    async function handleCandidateSelected() {
        if(pending) return;
        setOpenConfirmCandidateSelected(false);

        setPending(true);

        const result = await axios.post(`${window.location.origin}/api/jobs/helpers/selectCandidate`, {
            requestingUserID: session.user.token.id,
            jobID: jobID,
            userOfApplication: data.user
          }).catch((error) => {
              errorMsg(error?.response?.data?.status || error.toString())
          })
  
          if(result && result.status === 200) {
            setSelected(true);
            setAppSelectedCallback(data.user);
            successMsg("Application was selected for interview process.");
          }
  
          setPending(false);
    }

    async function handleCandidateHired() {
        if(pending) return;
        setOpenConfirmCandidateHired(false);
        
        setPending(true);

        const result = await axios.post(`${window.location.origin}/api/jobs/helpers/hireCandidate`, {
            requestingUserID: session.user.token.id,
            jobID: jobID,
            userOfApplication: data.user
          }).catch((error) => {
              errorMsg(error?.response?.data?.status || error.toString())
          })
  
          if(result && result.status === 200) {
            setHired(true);
            setAppHiredCallback(data.user);
            successMsg("Congratulations on your recent employment!");
          }
  
          setPending(false);
    }


    async function handleViewedApplication() {
        if(pending) return;
        if(viewed) {
            openApplication();
        } else {
            setPending(true);

            const result = await axios.post(`${window.location.origin}/api/jobs/helpers/applicationViewed`, {
                requestingUserID: session.user.token.id,
                jobID: jobID,
                userOfApplication: data.user
              }).catch((error) => {
                  errorMsg(error?.response?.data?.status || error.toString())
              })
      
              if(result && result.status === 200) {
                openApplication();
                setViewed(true);
              }
      
              setPending(false);
        }
    }

    const [openConfirmRemoveResume, setOpenConfirmRemoveResume] = useState(false);

    async function handleRemoveApplication() {
        if(pending) return;

        setPending(true);
        setOpenConfirmRemoveResume(false);

        const result = await axios.post(`${window.location.origin}/api/jobs/helpers/removeApplication`, {
            requestingUserID: session.user.token.id,
            jobID: jobID,
            userOfApplication: data.user
          }).catch((error) => {
              errorMsg(error?.response?.data?.status || error.toString())
          })
  
          if(result && result.status === 200) {
            removeApplicationCallback(data.user);
            successMsg("Application was denied.");
          }
  
          setPending(false);
    }


    return (
        <div className={styles.appCard}>
            { pending ? <div id={styles.loadingApplication}>
                <PuffLoader size={30} color='white' />
            </div>
            :
            openConfirmRemoveResume ? <div id={styles.confirm}>
                <h1>Deny Application?</h1>
                <section>
                    <button onClick={handleRemoveApplication}>
                        <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                    </button>
                    <button onClick={() => setOpenConfirmRemoveResume(false)}>
                        <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                    </button>
                </section>
            </div>
            :
            openConfirmCandidateSelected ? <div id={styles.confirm}>
                <h1>Mark as Selected?</h1>
                <section>
                    <button onClick={handleCandidateSelected}>
                        <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                    </button>
                    <button onClick={() => setOpenConfirmCandidateSelected(false)}>
                        <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                    </button>
                </section>
            </div>
            :
            openConfirmCandidateHired ? <div id={styles.confirm}>
                <h1>Candidate Hired?</h1>
                <section>
                    <button onClick={handleCandidateHired}>
                        <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                    </button>
                    <button onClick={() => setOpenConfirmCandidateHired(false)}>
                        <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                    </button>
                </section>
            </div>
            :
            <>
                <section>
                    <FontAwesomeIcon onClick={handleViewedApplication} icon={faEye} id={styles.icon} />
                    <FontAwesomeIcon style={{display: hired ? 'none' : 'flex'}} onClick={() => setOpenConfirmRemoveResume(true)} icon={faXmark} id={styles.icon} />
                    <FontAwesomeIcon style={hired ? { backgroundColor: 'white', color: '#154734' } : {}} onClick={handleCandidateActions} icon={ !selected ? faFileCircleCheck : !hired ? faPersonCircleCheck : faCheck} id={styles.icon} />
                </section>
                <section>
                    <FontAwesomeIcon icon={faFile} id={styles.icon} />
                    <div>
                        <div>
                            <h1>{data.name}</h1>
                            <h2>{displayString}</h2>
                        </div>

                        { viewed && <h3 style={{backgroundColor: 'white', color: '#154734'}}>Opened<FontAwesomeIcon icon={faCheck} id={styles.icon} /></h3> }
                        { !viewed && <h3>Unopened</h3> }
                    </div>
                </section>
            </>

             }
        </div>
    )
}

const ApplicationViewer = ({ data, closeViewer }) => {

    const newplugin = defaultLayoutPlugin();

    return (
        <section id={styles.appViewer}>

            <FontAwesomeIcon onClick={closeViewer} icon={faXmarkCircle} id={styles.exit} />

            <div>
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`} >
                    <Viewer theme='dark' fileUrl={data.resume} plugins={[newplugin]} />
                </Worker>
            </div>

        </section>
    )
}